export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('ArticlesCategories', () => {
        return {
          showCategoryOptions: false,
          toggleOptions() {
            this.showCategoryOptions = !this.showCategoryOptions;
          },
        };
      });
    });
  },
};
